module.exports = __WEBPACK_EXTERNAL_MODULE_156__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.promise"
// module id = 156
// module chunks = 0